import { CancelTokenSource } from 'axios';
import { EmployeeAccessTokenType } from 'ts-types/api.enums';
import { CheckEmailDto, EmployeeDto, EmployeeSearchRequest, UpsertEmployeeDto } from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/employees`;

export const searchEmployees = (
    employeeSearchRequest: Partial<EmployeeSearchRequest>,
    source: CancelTokenSource)
    : Promise<Array<EmployeeDto>> => {

  return axios
      .post(`${apiUri}/search`, employeeSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const findEmployeeById = (
    id: number, source: CancelTokenSource)
    : Promise<UpsertEmployeeDto> => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const saveEmployee = (
    upsertEmployeeDto: Partial<UpsertEmployeeDto>, source: CancelTokenSource)
    : Promise<UpsertEmployeeDto> => {

  return axios
      .post(apiUri, upsertEmployeeDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editEmployee = (
    id: number,
    upsertEmployeeDto: Partial<UpsertEmployeeDto>,
    source: CancelTokenSource)
    : Promise<EmployeeDto> => {

  return axios
      .put(`${apiUri}/${id}`, upsertEmployeeDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editEmployeeEmail = (
    id: number,
    email: string,
    source: CancelTokenSource)
    : Promise<string> => {

  const data = new FormData();
  data.set("email", email);

  return axios
      .post(`${apiUri}/${id}`, data, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteEmployee = (
    id: number, source: CancelTokenSource)
    : Promise<EmployeeDto> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const findAllByCompanyEmail = (
    companyEmail: string, source: CancelTokenSource)
    : Promise<CheckEmailDto[]> => {

  return axios
      .get(`${apiUri}/employee-email`,
          {params: {companyEmail: companyEmail}, cancelToken: source.token})
      .then(response => response.data);
}

export const createMipocoAccessLink = (
    employeeId: number,
    accessType: EmployeeAccessTokenType,
    source: CancelTokenSource): Promise<string> => {

  const formData = new FormData();
  formData.set("employeeId", employeeId.toString());
  formData.set("accessType", EmployeeAccessTokenType[accessType]);

  return axios
      .post(`${apiUri}/mipoco-access`, formData, {cancelToken: source.token})
      .then(response => response.data);
};
